import { ResultSeries } from './types';

const allowedModalities = [
  'CT',
  'US',
  'MRI',
  'MR',
  'CR',
  'NM',
  'XA',
  'PT',
  'RG',
  'RF',
  'HC',
  'DX',
  'MG',
  'PX',
  'BDUS',
  'BMD',
];

export default function seriesDisallowed(series: ResultSeries) {
  const modality = series['00080060']?.Value?.[0];
  if (!modality || !allowedModalities.includes(modality)) {
    return `Modality ${modality} not supported`;
  }
  return false;
}
